(function () {
  console.log('[CustomFee] Script loaded');
  window.__customFeeLoaded = true;

  const CUSTOMIZATION_VARIANT_ID = document.querySelector(
    '[data-embossing-select] option[data-embossing-option]',
  )?.dataset?.embossingOption || 47898898596151;
  const PROPERTY_NAME = 'Embossing';
  const originalFetch = window.fetch;

  function getCurrentEmbossingValue() {
    const el = document.querySelector(
      `[data-embossing-output], input[name="properties[${PROPERTY_NAME}]"]`
    );
    return el && el.value ? String(el.value).trim() : '';
  }

  window.fetch = async function (...args) {
    const [resource, config] = args;
    const url = typeof resource === 'string' ? resource : resource?.url || '';

    if (!url.includes('/cart/add')) {
      return originalFetch.apply(this, args);
    }

    console.log('[CustomFee] Intercepted /cart/add', { url, config });

    let embossedQty = 0;
    const currentEmbossing = getCurrentEmbossingValue();
    console.log('[CustomFee] Current embossing value:', currentEmbossing);

    let bodyType = 'unknown';
    let parsed = null;

    try {
      const body = config?.body;

      if (typeof body === 'string') {
        bodyType = 'json';
        parsed = JSON.parse(body);
      } else if (body instanceof FormData) {
        bodyType = 'formdata';
        parsed = body;
      } else if (body instanceof URLSearchParams) {
        bodyType = 'urlsearchparams';
        parsed = body;
      }

      console.log('[CustomFee] Body type:', bodyType);

      if (currentEmbossing) {
        if (bodyType === 'json' && parsed) {
          if (parsed.items && Array.isArray(parsed.items)) {
            parsed.items.forEach(item => {
              if (Number(item.id) === CUSTOMIZATION_VARIANT_ID) return;
              item.properties = item.properties || {};
              if (!item.properties[PROPERTY_NAME]) {
                item.properties[PROPERTY_NAME] = currentEmbossing;
              }
              embossedQty += Number(item.quantity) || 1;
            });
          } else if (parsed.id && Number(parsed.id) !== CUSTOMIZATION_VARIANT_ID) {
            parsed.properties = parsed.properties || {};
            if (!parsed.properties[PROPERTY_NAME]) {
              parsed.properties[PROPERTY_NAME] = currentEmbossing;
            }
            embossedQty = Number(parsed.quantity) || 1;
          }
          args[1] = { ...config, body: JSON.stringify(parsed) };

        } else if (bodyType === 'formdata' || bodyType === 'urlsearchparams') {
          const itemId = parsed.get('id');
          if (itemId && Number(itemId) !== CUSTOMIZATION_VARIANT_ID) {
            const propKey = `properties[${PROPERTY_NAME}]`;
            if (!parsed.get(propKey) || !String(parsed.get(propKey)).trim()) {
              parsed.set(propKey, currentEmbossing);
            }
            embossedQty = Number(parsed.get('quantity')) || 1;
          }
          args[1] = { ...config, body: parsed };
        }
      }

      console.log('[CustomFee] Embossed quantity:', embossedQty);
    } catch (err) {
      console.warn('[CustomFee] Could not parse body', err);
    }

    const response = await originalFetch.apply(this, args);
    console.log('[CustomFee] Original cart/add response status:', response.status);

    if (embossedQty > 0 && response.ok) {
      try {
        const cartRes = await originalFetch('/cart.js');
        const cart = await cartRes.json();
        const existingFee = cart.items.find(
          item => item.variant_id === CUSTOMIZATION_VARIANT_ID
        );
        const currentFeeQty = existingFee ? existingFee.quantity : 0;
        const newFeeQty = currentFeeQty + embossedQty;

        console.log('[CustomFee] Current fee qty:', currentFeeQty, '→ new:', newFeeQty);

        if (existingFee) {
          const changeRes = await originalFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: existingFee.key,
              quantity: newFeeQty
            })
          });
          console.log('[CustomFee] Fee updated:', changeRes.status);
        } else {
          const feeRes = await originalFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: CUSTOMIZATION_VARIANT_ID,
                quantity: embossedQty,
                properties: { _fee: 'embossing' }
              }]
            })
          });
          const feeData = await feeRes.json();
          console.log('[CustomFee] Fee added:', feeRes.status, feeData);
        }

        // Dispatch cart:update with the shape Atelier's cart-items component expects
        try {
          const freshCartRes = await originalFetch('/cart.js');
          const freshCart = await freshCartRes.json();

          const productForm = document.querySelector(
            'product-form-component, [is="product-form-component"]'
          );
          const target = productForm || document.documentElement;
          target.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            composed: true,
            detail: {
              data: {
                source: 'product-form-component',
                // we hide the embossed products in the cart so no need to add them to counter
                itemCount: 0,
                cart: freshCart
              }
            }
          }));
        } catch (err) {
          console.warn('[CustomFee] Could not dispatch cart:update', err);
        }
      } catch (err) {
        console.error('[CustomFee] Error handling fee', err);
      }
    }

    return response;
  };
})();